// extracted by mini-css-extract-plugin
export default {"active-secret":"COt4NlsqfwsBwV4YIgvi"};